import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Terms = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6 rounded-full" data-testid="terms-back-btn">
          <ArrowLeft className="mr-2 h-4 w-4" /> Back
        </Button>
        <h1 className="text-4xl sm:text-5xl font-bold text-secondary mb-6">Terms of Service</h1>
        <div className="space-y-5 text-foreground/80 text-base leading-relaxed">
          <p>Last updated: {new Date().getFullYear()}</p>
          <p>Welcome to Revivedu. By using revivedu.com you agree to these placeholder terms. Please read them carefully.</p>
          <h2 className="text-xl font-bold text-secondary pt-2">Using Revivedu</h2>
          <p>Revivedu provides AI-generated, curriculum-aligned learning activities intended to support parents and guardians. Activities are suggestions and should be supervised by an adult.</p>
          <h2 className="text-xl font-bold text-secondary pt-2">Your account</h2>
          <p>You are responsible for keeping your login details secure and for the activity that happens under your account.</p>
          <h2 className="text-xl font-bold text-secondary pt-2">Content</h2>
          <p>Generated content is provided "as is" for educational purposes. Always use your judgement about what is appropriate and safe for your child.</p>
          <h2 className="text-xl font-bold text-secondary pt-2">Contact</h2>
          <p>Questions? Email us at <a className="text-primary font-semibold hover:underline" href="mailto:hi@revivedu.com">hi@revivedu.com</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
